import React from "react";
import {Navbar, Header} from "./index"
import kontakt from "../assets/kontakt.jpg"
import { BsInstagram,BsFacebook } from "react-icons/bs"
import instagram from "../assets/instagram-logo.png"
import mail from "../assets/email.svg"
import BingMapsReact from "bingmaps-react";

const Kontakt = () => {
    return (
        <>
            <Header text="Kontakt" background={kontakt}/>
            <Main />
        </>
    );
}

export default Kontakt;

const Main = () => {

    const pushPin = {
        center: {
            latitude: 47.664089,
            longitude: 9.495175
        },
        options: {
            title: "Schütze Bau",
        },
    }
    const pushPins = [pushPin];

    return(
        <div className="flex justify-around mt-20">
            <div className="pt-7">
                <div className="kontaktzeile">
                    <h2 className="text-2xl font-Georgia">Schütze GmbH - Bauunternehmen</h2>
                </div>
                <div className="kontaktzeile">
                    Telefon: <a href="tel:+49754174872" className="text-red-800">+49 (0)7541 74872</a>
                </div>
                <div className="kontaktzeile">
                    Fax: <a href="fax:+4975413786491" className="text-red-800">+49 (0)7541 3786491</a>
                </div>
                <div className="kontaktzeile">
                    Adresse: <a href="https://maps.app.goo.gl/pbDy6cg46yahk1Pu9" target="_blank" className="text-red-800">Barbarossastraße 43, 88046 Friedrichshafen</a>
                </div>
                <div className="kontaktzeile">
                    Email: <a href="mailto:info@bau-schuetze.de" className="text-red-800">info@bau-schuetze.de</a>
                </div>
            </div>
            <div className="h-72 w-[35rem]">

                <BingMapsReact
                    bingMapsKey="AtRFe2MdXu29rgQ64SE0mS3wS6IzZudRC0Zpeo--73Ce_I0f5Swnm-pBY6ARw4bP"
                    pushPins={pushPins}
                    viewOptions={{
                        center: { latitude: 47.664089, longitude: 9.495175 },
                        zoom: 12,
                    }}
                />
            </div>
        </div>
    );
}
